export enum Decision {
  Yes = 'YES',
  No = 'NO',
  NotSpecified = 'NOT_SPECIFIED',
}
